import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import 'bootswatch/dist/lumen/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
